import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Card, Col, Form, Row, Space } from "antd";
import ButtonComponent from "components/ButtonComponent";
import DrawerComponent from "components/DrawerComponent";
import TableComponent from "components/TableComponent";
import TableConfig from "components/TableConfig";
import FormComponent from "components/form/FormComponent";
import InputCheckbox from "components/form/InputCheckbox";
import InputSelect from "components/form/InputSelect";
import InputText from "components/form/InputText";
import { SuccessNotification } from "components/popup/Notifications";
import PopDelete from "components/popup/PopDelete";
import useFormHook from "hooks/useFormHook";
import React, { useEffect, useState } from "react";
import { Post } from "utils/CrudApi";
import { Operations } from "utils/constants";

const initialValues = {
    OperationId: 1,
    Name: '',
    Address: '',
    ContactNumber: '',
    Person: '',
    NTN: '',
    Enabled: true,
    CreditPeriodDays: 0
  };

export default function Supplier() {
    const {
        isLoading,
        isTableLoading,
        handleDelete,
        handleDrawer,
        handleEdit,
        handleSearch,
        handleSubmit,
        open,
        add,
        formData,
        search,
        dataSet,
        transformOptions
      } = useFormHook("Supplier", initialValues);

      const columns = [
        {
          key: "1",
          title: "Name",
          dataIndex: "Name",
          filterSearch: true,
        },
        {
          key: "2",
          title: "Address",
          dataIndex: "Address",
          filterSearch: true,
        },
        {
          key: "3",
          title: "Contact Number",
          dataIndex: "ContactNumber",
        },
        {
          key: "4",
          title: "Person",
          dataIndex: "Person",
        },
        {
          key: "5",
          title: "NTN",
          dataIndex: "NTN",
        },
        {
          key: "6",
          title: "Credit Period Days",
          dataIndex: "CreditPeriodDays",
        },
        {
          key: "7",
          title: "Enabled",
          dataIndex: "Enabled",
          render: (_,record)=> record?.Enabled ? 'Yes':'No'
        },
        {
          key: "8",
          title: "Action",
          // className: "text-center",
          render: (_, record) => (
            <Space>
              {" "}
              <ButtonComponent
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />{" "}
              <PopDelete handleDelete={() => handleDelete(record)}>
                <ButtonComponent icon={<DeleteOutlined />} danger={true} />{" "}
              </PopDelete>
            </Space>
          ),
        },
      ];

      const formfields = (
        <>
          <Row gutter={[20, 0]}>
            <Col xs={24} md={12} xl={8}>
              <InputText label={"Name"} name={"Name"} required />
            </Col>
            <Col xs={24} md={12} xl={8}>
              <InputText label={"Address"} name={"Address"} required />
            </Col>
            <Col xs={24} md={12} xl={8}>
              <InputText label={"Contact Number"} name={"ContactNumber"} required />
            </Col>
            <Col xs={24} md={12} xl={8}>
              <InputText label={"Person"} name={"Person"} required />
            </Col>
            <Col xs={24} md={12} xl={8}>
              <InputText label={"NTN"} name={"NTN"}  required />
            </Col>
            <Col xs={24} md={12} xl={8}>
              <InputText label={"Credit Period Days"} name={"CreditPeriodDays"} required />
            </Col>
            <Col xs={3} md={3} xl={3} className="flex align-center">
              <InputCheckbox label={"Enabled"} name={"Enabled"} />
            </Col>
          </Row>
        </>
      );

      const searchfields = (
        <>
          <Row gutter={[20, 0]}>
            <Col xs={24} md={12} xl={8}>
              <InputText label={"Name"} name={"Name"} />
            </Col>
            <Col xs={24} md={12} xl={8}>
              <InputText label={"Credit Period Days"} name={"CreditPeriodDays"} />
            </Col>
          </Row>
        </>
      );

    return (
        <>
      <FormComponent
        title={"Search Supplier"}
        children={searchfields}
        handleSubmit={handleSearch}
        form={search}
        submit={"Search"}
        isLoading={isLoading}
        initialValues={initialValues}
        extra={
          <ButtonComponent
            icon={<EditOutlined />}
            text={"Add"}
            size={"small"}
            onClick={()=>handleDrawer(Operations.Insert)}
          />
        }
      />
      <br />
      <TableComponent
        columns={columns || []}
        rows={dataSet?.Table1 || []}
        title={"Supplier List"}
        loading={isTableLoading}
      />
      <DrawerComponent onClose={()=>handleDrawer(Operations.Select)} open={open}>
        <FormComponent
          children={formfields}
          handleSubmit={handleSubmit}
          form={add}
          submit={formData.OperationId == Operations.Update ? "Update" : "Save"}
          isLoading={isLoading}
          initialValues={initialValues}
        />
      </DrawerComponent>
    </>
    )
}